export const soundsPath = '1.Match-turning%20card-final.ogg^2.Match-turning%20card%20back-final.ogg^3.Match-matching%20successfully-final.ogg^4.Match-all%20matched-claps-final.ogg^5.Drag-drag%20to%20the%20line-final.ogg^6.Drag-fly%20back-final.ogg^7.Drag-matched-final.ogg^8.Drag-matched-claps-final.ogg^9.Line%20up-matched-final.ogg^10.Line%20up-claps-final.ogg^11.Think%20over-right-claps-final.ogg^12.Think%20over-wrong-nope-final.ogg^13.Think%20over-wrong-oh,sorry%20try%20again-final.ogg^14.Think%20over-wrong-no%20keep%20trying-final.ogg^15.Think%20over-wrong-not%20quite%20but%20try%20again-final.ogg^16.Pick%20out-wrong-woops-final.ogg^17.Pick%20out-right-you%20got%20it-final.ogg^match_help_fillin.ogg^match_help_lineup.ogg^matchgame_help_phrase.ogg^match_help_spell.ogg^match_help_text_to_image.ogg^match_help_text_to_text.ogg^matchgame_help.ogg^matchgame_help_causes.ogg^matchgame_help_definitions.ogg^matchgame_help_letters.ogg^matchgame_help_rhyme.ogg^matchgame_help_solutions.ogg^matchgame_help_sounds.ogg^quiz_help_content.ogg^quiz_help_image.ogg^quiz_help_text_image.ogg^quiz_help_text_image_audio.ogg';
export const SOUNDS_SIZE = 1494818;

export const matchUpSounds = {
  handle: '1.Match-turning%20card-final.ogg',
  wrong: '2.Match-turning%20card%20back-final.ogg',
  right: '3.Match-matching%20successfully-final.ogg',
  allRight: '4.Match-all%20matched-claps-final.ogg',
};

export const fillInSounds = {
  handle: '5.Drag-drag%20to%20the%20line-final.ogg',
  allRight: '4.Match-all%20matched-claps-final.ogg',
};

export const lineUpSounds = {
  handle: '5.Drag-drag%20to%20the%20line-final.ogg',
  allRight: '10.Line%20up-claps-final.ogg',
};

export const lineUpPicSounds = {
  handle: '5.Drag-drag%20to%20the%20line-final.ogg',
  allRight: '8.Drag-matched-claps-final.ogg',
};

export const pickOutSounds = {
  wrong: '16.Pick%20out-wrong-woops-final.ogg',
  allRight: '17.Pick%20out-right-you%20got%20it-final.ogg',
};

export const thinkOverSounds = {
  wrong: [
    '12.Think%20over-wrong-nope-final.ogg',
    '13.Think%20over-wrong-oh,sorry%20try%20again-final.ogg',
    '14.Think%20over-wrong-no%20keep%20trying-final.ogg',
    '15.Think%20over-wrong-not%20quite%20but%20try%20again-final.ogg',
  ],
  allRight: '11.Think%20over-right-claps-final.ogg',
};

export const spellOutSounds = {
  handle: '5.Drag-drag%20to%20the%20line-final.ogg',
  allRight: '4.Match-all%20matched-claps-final.ogg',
};
